


// // ## overviewdialognew.tsx
// import React, { useEffect, useState } from 'react';
// import { Box, Flex, Text, Textarea } from '@chakra-ui/react';
// import Select from 'react-select';

// interface Props {
//   formData: any;
//   overviewDialogs: any[];
//   setOverviewDialogs: (val: any[]) => void;
// }

// const Overviewdialognew: React.FC<Props> = ({
//   formData,
//   overviewDialogs,
//   setOverviewDialogs,
// }) => {
//   // ## ACTIVE dialog index
//   const [activeIndex, setActiveIndex] = useState<number | null>(null);

//   // ## Character options
//   const [characterOptions, setCharacterOptions] = useState<any[]>([]);

//   useEffect(() => {
//     setCharacterOptions([
//       { value: 999999, label: 'Player' },
//       { value: 99999, label: 'Narrator' },
//       {
//         value: formData?.gameNonPlayingCharacterId,
//         label: formData?.gameNonPlayerName,
//       },
//     ]);
//   }, [formData]);

//   // ## Emotion options
//   const emotionOptions = [
//     // { value: 'Talking', label: 'Talking' },
//     // { value: 'Asking', label: 'Asking' },
//     // { value: 'Agreeing', label: 'Agreeing' },
//     // { value: 'Happy', label: 'Happy' },
//     // { value: 'Angry', label: 'Angry' },
//     // { value: 'Idle', label: 'Idle' },

//      { value: 'Talking', label: 'Talking' },
//     { value: 'Asking', label: 'Asking' },
//     { value: 'Agreeing', label: 'Agreeing' },
//     { value: 'Saying no', label: 'Saying no' },
//     { value: 'Happy', label: 'Happy' },
//     { value: 'Disappointed', label: 'Disappointed' },
//     { value: 'Angry', label: 'Angry' },
//     { value: 'Idle', label: 'Idle' },
//   ];

//   const selectStyles = {
//     menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
//     control: (provided: any) => ({
//       ...provided,
//       borderRadius: '15px',
//       background: 'transparent',
//       width: '150px',
//     }),
//   };

//   // ## Update handler → PARENT STATE
//   // const updateDialog = (i: number, key: string, value: any) => {
//   //   const copy = [...overviewDialogs];
//   //   copy[i] = { ...copy[i], [key]: value };
//   //   setOverviewDialogs(copy);
//   // };

//   const updateDialog = (i: number, key: string, value: any) => {
//   const copy = [...overviewDialogs];
//   copy[i] = { ...copy[i], [key]: value };
//   setOverviewDialogs(copy); // ## lift state up
// };


//   return (
//     <Box>
//       {overviewDialogs.map((item, i) => (
//         <Box
//           key={i}
//           onClick={() => setActiveIndex(i)}
//           borderRadius="20px"
//           p="16px"
//           mb="14px"
//           border={
//             activeIndex === i
//               ? '2px solid #3182ce'
//               : '1px solid transparent'
//           }
//         >
//           <Text mb="8px">Dialog {i + 1}</Text>

//           <Flex gap="10px" flexDirection={{ base: 'column', lg: 'row' }}>
//             {/* ## Character */}
//             <Select
//               options={characterOptions}
//               value={item.character}
//               onChange={(v) => updateDialog(i, 'character', v)}
//               styles={selectStyles}
//             />

//             {/* ## Dialog Text */}
//             <Textarea
//               value={item.dialog}
//               onChange={(e) =>
//                 updateDialog(i, 'dialog', e.target.value)
//               }
//             />

//             {/* ## Emotion */}
//             <Select
//               isMulti
//               options={emotionOptions}
//               value={item.emotion}
//               onChange={(v) => updateDialog(i, 'emotion', v)}
//               isOptionDisabled={() => item.emotion.length >= 2}
//               styles={selectStyles}
//             />
//           </Flex>
//         </Box>
//       ))}
//     </Box>
//   );
// };

// export default Overviewdialognew;


//yaswanthcode



// ## overviewdialognew.tsx
import React, { useEffect, useState } from 'react';
import { Box, Flex, Text, Textarea } from '@chakra-ui/react';
import Select from 'react-select';

interface Props {
  formData: any;
  overviewDialogs: any[];
  setOverviewDialogs: (val: any[]) => void;
}

const questOptions = [
  { value: 1, label: 'Quest 1' },
  { value: 2, label: 'Quest 2' },
  { value: 3, label: 'Quest 3' },
  { value: 4, label: 'Quest 4' },
  { value: 5, label: 'Quest 5' },
];

const Overviewdialognew: React.FC<Props> = ({
  formData,
  overviewDialogs,
  setOverviewDialogs,
}) => {
  // ## ACTIVE dialog index
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  // ## Character options
  const [characterOptions, setCharacterOptions] = useState<any[]>([]);

  useEffect(() => {
    setCharacterOptions([
      { value: 999999, label: 'Player' },
      { value: 99999, label: 'Narrator' },
        { value: 9999, label: 'Mentor' },
      // {
      //   value: formData?.gameNonPlayingCharacterId,
      //   label: formData?.gameNonPlayerName,
      // },
      ...(Array.isArray(formData?.gameNonPlayerOption)
  ? formData.gameNonPlayerOption.map((npc: any) => ({
      value: npc.gasId,
      label: npc.name,
    }))
  : []),
    ]);
  }, [formData]);

  // ## Emotion options
  const emotionOptions = [
    // { value: 'Talking', label: 'Talking' },
    // { value: 'Asking', label: 'Asking' },
    // { value: 'Agreeing', label: 'Agreeing' },
    // { value: 'Happy', label: 'Happy' },
    // { value: 'Angry', label: 'Angry' },
    // { value: 'Idle', label: 'Idle' },

    { value: 'Talking', label: 'Talking' },
    { value: 'Asking', label: 'Asking' },
    { value: 'Agreeing', label: 'Agreeing' },
    { value: 'Saying no', label: 'Saying no' },
    { value: 'Happy', label: 'Happy' },
    { value: 'Disappointed', label: 'Disappointed' },
    { value: 'Angry', label: 'Angry' },
    { value: 'Idle', label: 'Idle' },
    { value: 'walk2', label: 'Walk', key: 10 }
  ];

  const selectStyles = {
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
    control: (provided: any) => ({
      ...provided,
      borderRadius: '15px',
      background: 'transparent',
      width: '150px',
    }),
  };

  // ## Update handler → PARENT STATE
  // const updateDialog = (i: number, key: string, value: any) => {
  //   const copy = [...overviewDialogs];
  //   copy[i] = { ...copy[i], [key]: value };
  //   setOverviewDialogs(copy);
  // };

  const updateDialog = (i: number, key: string, value: any) => {
    const copy = [...overviewDialogs];
    copy[i] = { ...copy[i], [key]: value };
    setOverviewDialogs(copy); // ## lift state up
  };


  return (
    <Box>
      {overviewDialogs.map((item, i) => (
        <Box
          key={i}
          onClick={() => setActiveIndex(i)}
          borderRadius="20px"
          p="16px"
          mb="14px"
          border={
            activeIndex === i
              ? '2px solid #3182ce'
              : '1px solid transparent'
          }
        >
          <Text mb="8px">Dialog {i + 1}</Text>

          <Flex gap="10px" flexDirection={{ base: 'column', lg: 'row' }}>


            {/*  Quest Selector */}
            <Select
              options={questOptions}
              value={item.quest}
              onChange={(v) => updateDialog(i, 'quest', v)}
              placeholder="Quest"
              styles={selectStyles}
            />

            {/* ## Character */}
            <Select
              options={characterOptions}
              value={item.character}
              onChange={(v) => updateDialog(i, 'character', v)}
              styles={selectStyles}
            />

            {/* ## Dialog Text */}
            <Textarea
              value={item.dialog}
              onChange={(e) =>
                updateDialog(i, 'dialog', e.target.value)
              }
            />

            {/* ## Emotion */}
            <Select
              isMulti
              options={emotionOptions}
              value={item.emotion}
              onChange={(v) => updateDialog(i, 'emotion', v)}
              isOptionDisabled={() => item.emotion.length >= 2}
              styles={selectStyles}
            />
          </Flex>
        </Box>
      ))}
    </Box>
  );
};

export default Overviewdialognew;



